import {
  CategoriesServicesObjectData,
  SectionOrServiceForTable
} from '../../../types/Admin/CategoriesTopicsTypes';
import { findSectionOrServiceRowById } from './findSectionOrServiceRowById';
import { parseItemIconSettings } from './parseItemIconSettings';

export const resolveIconSettingsForEdit = (
  modalData: SectionOrServiceForTable | null | undefined,
  tableData: CategoriesServicesObjectData | undefined,
  kind: 'section' | 'service'
) => {
  if (!modalData?.id) {
    return parseItemIconSettings(null);
  }

  const fromModal = parseItemIconSettings(modalData);
  if (fromModal.iconUrl) {
    return fromModal;
  }

  if (!tableData) {
    return fromModal;
  }

  if (kind === 'service') {
    const fromServices = tableData.services?.find((row) => row.id === modalData.id);
    if (fromServices?.iconUrl) {
      return parseItemIconSettings(fromServices);
    }
  } else {
    const fromSections = tableData.sections?.find((row) => row.id === modalData.id);
    if (fromSections?.iconUrl) {
      return parseItemIconSettings(fromSections);
    }
  }

  const fromAll = findSectionOrServiceRowById(tableData.all, modalData.id);
  if (fromAll?.iconUrl) {
    return parseItemIconSettings(fromAll);
  }

  return fromModal;
};
